import { startCase } from 'lodash';

const filter = (value): string => {
  if (!value) {
    return ''
  }

  return startCase(value.toLowerCase())
}

export default filter
